import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  public currentYear: number;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

}
